/**
 * 全局混入
 */
// Vue.prototype.t = i18n.t
Vue.mixin({
    i18n,
    directives: {
        keyword: {
            //防止报错
        }
    },
    async created() {
        //兼容element-ui使用老版本的i18n
        this.t = this.$t
        await Promise.all([this.getLoginUserInfo(), this.getPermissionList()])
        //在组件内使用this.$on('ready'即可监听用户、权限信息初始化完成
        this.$emit('ready')
    },
    data() {
        return {
            hasLogin: false,
            loginUserInfo: undefined,
            loginHref: "/",
            baseUrl: "",
            roleModules: [],
            moduleFeatures: {},
            sysModules: [],
            sysModulesFormat: [],
            sysModulesObj: {},
            bannerPlateType: bannerPlateType,
            permissionList: [],
            libraryDateFormat: [],
            libraryDateObj: {},
            workUrl: "/unifiedplatform/v1/app/workbench/direction",
            navSearchKeyword: '',
            headActive: false,
            navClassificationTypeList: [],//省平台职教导航数据
            unreadMessageCount: 0,
            messages: [],
            messageCount: 0,
            hideNavSearch: false,//隐藏顶部搜索框
            searchHistoryList: [],//搜索历史列表
            ifManager: false,//是否是管理员
            ifTeacher: false,//是否是教师
            ifStudent: false, //是否是学生
            hideHead: false,//全局隐藏顶部导航
            showBackTop: false,
            lang: localStorage.getItem('lang') || 'zh',
            visiteData: {
                PC: 0,
                todayPC: 0,
                mobile: 0,
                todayMobile: 0
            },
            theme_8_common: {
                dateInfo: {
                    date: new Date().getFullYear() + '.' + (new Date().getMonth() + 1) + '.' + new Date().getDate(),
                    weekday: ['日', '一', '二', '三', '四', '五', '六'][new Date().getDay()]
                },
                chickenSoup: [
                    '只会幻想而不行动的人，永远也体会不到收获果实时的喜悦。',
                    '嘲讽是一种力量，消极的力量。赞扬也是一种力量，但却是用心的力量。',
                    '目标的坚定是性格中最必要的力量源泉之一，也是成功的利器之一。没有它，天才会在矛盾无定的迷径中徒劳无功。',
                    '青春就像一只容器，装满了不安躁动青涩与偶尔的疯狂。',
                    '同伴，不一定非要走到最后，某一段路上，对方给自己带来的朗朗笑声，那就已经足够。',
                    '不去期望，失去了不会伤心，得到了便是惊喜。',
                    '咱们什么都没有，唯一的本钱就是青春。梦想让我与众不一样，奋斗让我改变命运!',
                    '障碍与失败，是通往成功最稳靠的踏脚石，肯研究利用它们，便能从失败中培养出成功。',
                    '失去金钱的人损失甚少，失去健康的人损失极多，失去勇气的人损失一切。',
                    '踏平坎坷成大道，推倒障碍成浮桥，熬过黑暗是黎明。',
                    '恐惧自我受苦的人，已经正因自我的恐惧在受苦。',
                    '成功的信念在人脑中的作用就如闹钟，会在你需要时将你唤醒。',
                    '过错是暂时的遗憾，而错过则是永远的遗憾！',
                    '所谓的人间烟火，就是这样—个可以时而温暖时而冷漠的词语，所谓的人间，就是这样时而光明时而黑暗的时刻。',
                    '当你孤独时，风儿就是我的歌声，愿它能使你得到片刻的安慰；当你骄傲时，雨点就是我的警钟，愿它能使你获得永恒的谦逊。',
                    '生命的美，不在它的绚烂，而在它的平和；生命的动人，不在它的激情，而在它的平静。惟平和，才见生命的广大；惟平静，才见生命的深远。',
                    '友情如水，淡而长远；友情如茶，香而清纯；友情如酒，烈而沁心；友情如雨，细而连绵；友情如雪，松而亮洁。人生短暂，珍惜友情。',
                    '如果你生气了，请在面对爱人之前先面对镜子。看看自己，你喜欢现在这张脸吗？',
                    '生活不是林黛玉，不会因为忧伤而风情万种。',
                    '自信就如一副眼镜，帮助近视的人打开光明之路；自信就如一台电脑帮助无知的人们开阔视野；自信就如一台学习机，帮助学习差的同学提高成绩；',
                    '使我们不快乐的，都是一些芝麻小事，我们可以躲闪一头大象，却躲不开一只苍蝇。',
                    '行动那才是最重要的，而每个行动都有其代价和欢乐之处，人生的旅行过程给我快乐，而不是那目的地。',
                    '成功者和其他人最大的区别就是，他们真正动手去做了。',
                    '坚持自己的梦想，即使没有翅膀也能飞翔。',
                    '是我的，终归是我的；不是我的，再去争取也会灰飞烟灭，何必呢？还是默默在角落做好一个旁观者，顺其自然，随遇而安，好好过自己的生活。',
                    '任何事物都不如习惯那样强有力。',
                    '人生也是如此，同样是进退留转，对心态好的人来说是一种职责，是一股动力；而对心态差的人来说，把握不好，则会给心理身体家庭和事业带来负面影响。',
                    '不好问别人为你做了什么，而要问你为别人做了什么。',
                    '性命太过短暂，这天放下了明天不必须能得到。',
                    '让生活的句号圈住的人，是无法前时半步的。',
                    '自我打败自我是最可悲的失败，自我战胜自我是最可贵的胜利。',
                    '你一天的爱心可能带来别人生命的感谢。',
                    '人生，就要闯出条路来！',
                    '最常见的勇气就是在日常生活中做到诚实和正直，能够抵制诱惑，敢于讲真话，表现自我真实的一面，而不好虚伪造作。',
                    '用行动开启完美，用智慧点亮人生，用信心激励自我，用勇气点燃激情，用执着守候成功，用发奋打造精彩，用奋斗创造辉煌，用拼搏开拓未来！',
                    '金钱损失了还能挽回，一旦失去信誉就很难挽回。',
                    '当你无法从一楼蹦到三楼时，不好忘记走楼梯。要记住伟大的成功往往不是一蹴而就的，务必学习并领悟分解你的目标，逐步实施。',
                    '不好对挫折叹气，姑且把这一切看成是在你成大事之前，务必经受的准备工作。',
                    '奋斗没有终点，任何时候都是一个起点。',
                    '不大可能的事也许这天实现，根本不可能的事也许明天会实现。',
                    '没有人富有得能够不好别人的帮忙，也没有人穷得不能在某方面给他人帮忙。',
                    '同在一个环境中生活，强者与弱者的分界就在于谁能改变它。',
                    '用行动祈祷比用言语更能够使上帝了解。',
                    '坚信就是强大，怀疑只会抑制潜质，而信仰就是力量。',
                    '在真实的性命里，每桩伟业都由信心开始，并由信心跨出第一步。',
                    '自我打败自我是最可悲的失败，自我战胜自我是最可贵的胜利。',
                ].filter(t => t.length <= 26)[new Date().getDate() > 15 ? (new Date().getDate() - 15) : new Date().getDate()]
            },
            zoom: 1,
            enums: window.app?.enums,
            recordingActive: false, //搜索框录音按钮状态
            targetCustomer: 'shaanxiiitc',
            showName: '1',
            isMac: navigator.userAgent.indexOf('Macintosh') !== -1,
            provincialPlatformHeaderConfig: {},//省平台头部配置
            isHeaderInputFocus: false,
        };
    },
    watch: {
        navSearchKeyword(newVal){
            //过滤掉特殊符号
            this.navSearchKeyword = newVal.replace(/[^\u4e00-\u9fa5\w\s]/g, '')
        }
    },
    async mounted() {
        let that = this
        that.$nextTick(() => {
            if (!that.scrollNavStatus) return
            let scrollBox
            if (document.querySelector('.scroll_container')) {
                scrollBox = document.querySelector('.scroll_container')
            } else {
                scrollBox = window
            }
            scrollBox.addEventListener('scroll', debounce(that.scrollNavInit, 100))
        });
        that.watchWindowSize();
        window.addEventListener('resize', debounce(that.watchWindowSize, 100));
        this.initSystem()
        this.handleShTechBg()
        // this.initBannerType4()
        if (this.lang == 'en') {
            let arr = document.title.split('-')
            let arr_en = arr.map(zh => zh == window.browserTabAbbreviation ? window.browserTabAbbreviation_en : this.$t(zh))
            document.title = arr_en.join('-')
        }
    },
    methods: {
        initSystem() {
            function getQueryVariable(variable) {
                var query = window.location.search.substring(1);
                var vars = query.split("&");
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split("=");
                    if (pair[0] == variable) { return pair[1]; }
                }
                return (false);
            }
            var hideHead = getQueryVariable('hideHead') || sessionStorage.getItem('hideHead');
            if (hideHead) {
                this.hideHead = hideHead
                sessionStorage.setItem('hideHead', true)
                this.$nextTick(() => {
                    if (!this.getIfPc()) {
                        // 小程序移动端禁用所有target _blank
                        // 获取所有的 <a> 标签
                        var links = document.getElementsByTagName('a');
                        // 遍历 <a> 标签集合并检查 target 属性
                        Array.prototype.forEach.call(links, function (link) {
                            // 检查是否有 target="_blank" 属性
                            if (link.getAttribute('target') === '_blank') {
                                // 移除 target 属性
                                link.removeAttribute('target');
                            }
                        });
                    }
                })
            }
        },
        //动态给分页添加适配移动端属性
        watchWindowSize() {
            this.getZoom();
            const w = document.documentElement.clientWidth;
            const pagination = document.getElementsByClassName('el-pagination')[0];
            const sizes = document.getElementsByClassName('el-pagination__sizes')[0];
            // console.log('watchWindowSize',w);
            if (!document.getElementsByClassName('el-pagination')[0]) return
            if (w < 570) {
                pagination && pagination.classList.add('el-pagination--small');
            } else {
                pagination && pagination.classList.remove('el-pagination--small');
            }
            if (!document.getElementsByClassName('el-pagination__sizes')[0]) return
            if (w < 450 && sizes) {
                sizes.style.display = 'none';
            } else {
                if (sizes) sizes.style.display = 'inline-block';
            }

        },
        getZoom() {
            let zoom = 1
            zoom = document.documentElement.clientWidth / 1920
            if (this.zoom != zoom) {
                this.zoom = zoom
            }
        },
        handleClickMessage(data) {
            if (!data.isRead) {
                API.updateMessageRead({ id: data.id }).then(res => {
                    if (res.errorCode === 'success') {
                        this.getUnreadMessageCount();
                        this.getMessages();
                    }
                })
            }
        },
        errorHandler() {
            return true;
        },
        handerNavSearch() {
            if (!this.navSearchKeyword) return this.$message.info('请输入关键词！')
            this.handleClickEventStatistics('search_click', { keyword: this.navSearchKeyword })
            location.href = location.origin + '/learn/global/search?keyword=' + this.navSearchKeyword
        },
        getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
            return '';
        },
        getMessagesAndUnreadCount() {
            if (window.messageGetLoading) return;
            window.messageGetLoading = true;
            this.getUnreadMessageCount();
            this.getMessages();
        },
        getUnreadMessageCount() {
            API.reqUnreadMessageCount().then(res => {
                if (res.errorCode === 'success') {
                    this.unreadMessageCount = res.extendMessage;
                }
            })
        },
        getMessages() {
            API.reqMessageList({ page: 1, size: 10, isRead: false }).then(res => {
                if (res.errorCode === 'success') {
                    window.messageGetLoading = false;
                    this.messages = [...res.extendMessage.results ?? []];
                    this.messageCount = res.extendMessage.recordTotal;
                }
            })
        },
        getLoginUserInfo() {
            const that = this
            //获取缓存中的用户信息
            try {
                this.loginUserInfo = JSON.parse(sessionStorage.getItem('learn_user'))
            } catch (err) {
                console.error(err)
                sessionStorage.removeItem('learn_user')
                this.loginUserInfo = null
            }
            return new Promise((resolve) => {
                if (window.loginStatus || window.hasLogin) {
                    // this.getMessagesAndUnreadCount()
                    return;
                }
                window.loginStatus = true;
                API.reqUserInfo({timestamp: new Date().getTime()})
                    .then((res) => {
                        if (res.status == 200) {
                            if (res.data.userInfo) {
                                this.getMessagesAndUnreadCount()
                                const timer = setInterval(this.getUnreadMessageCount, 10000);
                            }
                            let moduleCode = res.data.moduleCode.extendMessage || []
                            moduleCode.forEach(item => {
                                if (item.code == 'target_customer') {
                                    this.targetCustomer = item.value
                                }
                            })
                            let setting = res.data.tbPageSettings.data[0];
                            this.title = setting.title;
                            // this.loginHref = setting.defaultjumpaddress + '?redirect_url=' + encodeURIComponent(location.href)
                            this.loginHref = this.bannerPlateType == 15 ? "/unifiedlogin/#/?redirect_url=" + location.href : "/unifiedlogin/v1/loginmanage/login/direction?redirect_url=" + location.href;
                            window.loginHref = this.bannerPlateType == 15 ? "/unifiedlogin/#/?redirect_url=" + location.href : "/unifiedlogin/v1/loginmanage/login/direction?redirect_url=" + location.href;
                            this.loginUserInfo = res.data.userInfo;
                            window.loginUserInfo = res.data.userInfo;
                            sessionStorage.setItem("learn_user", JSON.stringify(res.data.userInfo));
                            this.ifManager = this.loginUserInfo ?
                                (this.loginUserInfo.user_code == 'sys' || this.loginUserInfo.user_code == 'zhiliao' ||
                                    this.loginUserInfo.roles?.includes("r_course_manager") || this.loginUserInfo.roles?.includes("r_second_manager") ||
                                    this.loginUserInfo.roles?.includes("r_sys_manager")) : false
                            window.ifManager = this.ifManager
                            this.ifTeacher = this.loginUserInfo ? this.loginUserInfo.roles?.includes("r_teacher") : false
                            window.ifTeacher = this.ifTeacher
                            this.ifStudent = this.loginUserInfo ? this.loginUserInfo.roles?.includes("r_student") : false
                            window.ifStudent = this.ifStudent
                            this.baseUrl = res.data.baseUrl || "";
                            this.roleModules =
                                res.data.rolemodule.extendMessage ? res.data.rolemodule.extendMessage.modules : [];
                            this.moduleFeatures =
                                res.data.rolemodule.extendMessage ? res.data.rolemodule.extendMessage.moduleFeatures : {};
                            this.sysModules = res.data.moduleCode ? res.data.moduleCode.extendMessage : [];
                            this.sysModulesObj = {}
                            this.sysModulesFormat = this.sysModules
                                .filter((item) => {
                                    this.sysModulesObj[item.code] = item.value
                                    if (item.code == 'target_customer') {
                                        this.targetCustomer = item.value
                                    }
                                    if (item.code == 'resource_map_display') {
                                        return item.moduleCode == 'LearningPortalResource' && item.value === "true"
                                    } else {
                                        return item.value === "true"
                                    }
                                })
                                .map((item) => item.code);
                            window.targetCustomer = this.targetCustomer
                            let libraryDateObj = {}
                            const libraryDate = res.data.libraryDate
                            libraryDate.map((item, index) => {
                                libraryDateObj[item.code] = item || {}
                            })
                            this.libraryDateObj = libraryDateObj
                            this.libraryDateFormat = libraryDate ? libraryDate.filter(item => item.value == 'true').map(item => item.code) : []
                            this.target_customer = this.sysModulesObj.target_customer
                            window.target_customer = this.target_customer

                            let showName = this.sysModulesObj.is_show_platform_name
                            this.showName = showName
                            try {
                                this.provincialPlatformHeaderConfig = JSON.parse(this.sysModulesObj.provincial_platform_header_config)
                            } catch (err) {
                                console.error(err)
                            }

                            // if (this.roleModules.includes('wdkc')) {
                            //     this.workUrl = "/learn/manager/#/home"
                            //     // } else if (this.moduleFeatures.zyzx && this.moduleFeatures.zyzx.includes('show_resource_management')) {
                            // } else if (this.roleModules.includes('zyzx') && this.moduleFeatures.zyzx && this.moduleFeatures.zyzx.includes('show_resource_management')) {
                            //     this.workUrl = "/rman/#/basic/rmanCenterList"
                            // } else if (this.roleModules.includes('SystemManagement')) {
                            //     this.workUrl = "/unifiedplatform/#/basic"
                            // } else if (this.roleModules.includes("zxjj") && this.moduleFeatures.zxjj.includes("jove_use")) {
                            //     this.workUrl = "/joveone"
                            // } else if(!this.roleModules.includes("wdkc")){
                            //     this.workUrl = "/rman/#/basic/rmanCenterList"
                            // }

                            // if (this.loginUserInfo && this.loginUserInfo.roles.includes('r_offcampusteam')) {
                            //     //校外团队
                            //     this.workUrl = "/rman/#/basic/rmanCenterList"
                            // }

                            //是否隐藏导航栏搜索框
                            if (this.sysModulesFormat.includes('hide_nav_search')) {
                                this.hideNavSearch = true
                            }

                            if (res.data.userInfo) {
                                window.hasLogin = true;
                                this.hasLogin = true
                            } else {
                                window.hasLogin = false;
                                this.hasLogin = false
                            }

                            //用户登录行为深度埋码方法
                            function depthStatisticsFun(userInfo) {
                                if (userInfo) {
                                    window.hasLogin = true;
                                    //由未登录状态变为登录即采集用户行为
                                    if (sessionStorage.getItem('hasLogin') != 'true') {
                                        const info = userInfo || {}
                                        //如采集用户信息是异步行为需要先执行这个BLOCK埋点
                                        window.depthStatistics({
                                            platform: 'aplus_queue',
                                            params: { action: 'aplus.setMetaInfo', arguments: ['_hold', 'BLOCK'] }
                                        })
                                        //获取异步回调结果中的用户账号id
                                        window.depthStatistics({
                                            platform: 'aplus_queue',
                                            params: { action: "aplus.setMetaInfo", arguments: ["_user_id", info.user_code] }
                                        })//使用智教中国通行证ID
                                        //再通过设置_hold=START允许采集上报
                                        window.depthStatistics({
                                            platform: 'aplus_queue',
                                            params: { action: "aplus.setMetaInfo", arguments: ['_hold', 'START'] }
                                        })
                                        //职业
                                        let roles = info.roles || []
                                        let occupation = roles.includes('r_sys_manager') ? '系统管理员' : roles.includes('r_course_manager') ? '课程管理员' : roles.includes('r_teacher') ? '教师' : roles.includes('r_student') ? '学生' : ''
                                        let sex = info.extend ? info.extend.sex : ''
                                        let sch = ''
                                        if (info.organizations && info.organizations.length) {
                                            sch = info.organizations[0].organization_name
                                        }
                                        //上报用户属性
                                        window.depthStatistics({
                                            platform: 'aplus_queue',
                                            params: {
                                                action: 'aplus.record',
                                                arguments: ['$$_user_profile', 'OTHER', { occupation, sch, sex }]
                                            }
                                        }).then(() => {
                                            sessionStorage.setItem('hasLogin', 'true')
                                        })
                                    }
                                } else {
                                    window.hasLogin = false;
                                    sessionStorage.setItem('hasLogin', 'false')
                                }
                            }

                            // 埋码js几部加载未统计到问题
                            let intervalTimes = 5
                            let tryInterval = setInterval(() => {
                                depthStatisticsFun(res.data.userInfo)
                                intervalTimes--
                                if (intervalTimes <= 0 || sessionStorage.getItem('hasLogin') == 'true') clearInterval(tryInterval)
                            }, 1000)

                            //自定一国际化
                            let customI18nStr = (this.sysModules.find(el => el.code == 'custom_i18n') || {}).value
                            if (customI18nStr) {
                                let arr = customI18nStr.split('$$')
                                let customZh = {}
                                let customEn = {}
                                arr.map(str => {
                                    let words = str.split('|')
                                    customZh[words[0]] = words[1]
                                    customEn[words[0]] = words[2]
                                })

                                global.i18n.mergeLocaleMessage('en', customEn)
                                global.i18n.mergeLocaleMessage('zh', customZh)
                            }
                        }
                        //页面权限控制
                        // this.authorizationPage();
                    })
                    .finally((_) => {
                        // window.loginStatus = false;
                        resolve()
                        this.$nextTick(() => {
                            setTimeout(() => {
                                if (that.bannerPlateType == 8) {
                                    global.menuInit({ parent: '.tabs_view_2 .menu_container', child: '.tabs_view_2 .menu_container .menu_view' })
                                } else if (that.bannerPlateType == 2 || that.bannerPlateType == 11) {
                                    global.menuInit({ parent: '.tabs_view .left_view', child: '.tabs_view .menu_view' })
                                } else {
                                    global.menuInit({ parent: '.tabs_view .parent_box', child: '.tabs_view .parent_box .menu_view' })
                                }
                            }, 100);
                        })
                    });
                //获取访问统计
                this.getVisiteStatisticsData()
            })
        },
        getVisiteStatisticsData() {
            const that = this
            let visiteData = { todayPC: 0, todayMobile: 0, PC: 0, mobile: 0 }
            Promise.all([API.reqVisiteStatistics({ date: 'd' }).then(res => {
                //日访问
                if (res.statusCode == 200) {
                    visiteData.todayPC = res.data.PC
                    visiteData.todayMobile = res.data.mobile
                }
            }), API.reqVisiteStatistics().then(res => {
                //总计
                if (res.statusCode == 200) {
                    visiteData.PC = res.data.PC
                    visiteData.mobile = res.data.mobile
                }
            })]).finally(() => {
                that.visiteData = { ...visiteData }
            })

        },
        getPermissionList() {
            return new Promise((resolve) => {
                // this.permissionList = [
                //     {
                //         "id": "65ecf5aa1bfrfgerreed6ed936747345",
                //         "parentId": "05586dc98a1d4b8baace70e4d48c1942",
                //         "guid": "65ecf5aa1bfrfgerreed6ed936747345",
                //         "code": "LearningPortalHomePage",
                //         "name": "首页",
                //         "disable": false,
                //         "isSystem": true
                //     },
                //     {
                //         "id": "93a59c7489ab4aa2b9c54d16582856e4",
                //         "parentId": "05586dc98a1d4b8baace70e4d48c1942",
                //         "guid": "93a59c7489ab4aa2b9c54d16582856e4",
                //         "code": "LearningPortalCourse",
                //         "name": "课程",
                //         "disable": false,
                //         "isSystem": true
                //     },
                //     {
                //         "id": "9422fb7aea2748d8b3cdeb96934756c6",
                //         "parentId": "05586dc98a1d4b8baace70e4d48c1942",
                //         "guid": "9422fb7aea2748d8b3cdeb96934756c6",
                //         "code": "LearningPortalClassReview",
                //         "name": "课堂回看",
                //         "disable": false,
                //         "isSystem": true
                //     },
                //     {
                //         "id": "96ecf5aa1b5e4924b8bd6ed9367479dd",
                //         "parentId": "05586dc98a1d4b8baace70e4d48c1942",
                //         "guid": "96ecf5aa1b5e4924b8bd6ed9367479dd",
                //         "code": "LearningPortalLiveStreaming",
                //         "name": "直播",
                //         "disable": false,
                //         "isSystem": true
                //     }
                // ].map((item) => item.code)
                // return;
                if (window.hasPermission) return;
                window.hasPermission = true;
                API.reqPermissionList({
                    moduleCode: "LearningPortal",
                    enable: true,
                }).then((res) => {
                    if (res.errorCode === "success") {
                        this.permissionList =
                            res.extendMessage ? res.extendMessage.map((item) => item.code) : [];
                    }
                }).finally(() => resolve());
            })
        },
        // authorizationPage() {
        //     let exceptNoLogin = [
        //         "/learn/",
        //         "/learn/home",
        //         "/learn/search",
        //         "/learn/videoreview",
        //         "/learn/live",
        //         "/learn/lib/list"
        //     ];
        //     // console.log('页面权限', !window.hasLogin && !exceptLoginAuth.includes(window.location.pathname))
        //     let unLoginShowValid = ['/learn/course/micro/', '/learn/course/detail/', '/learn/course/preview/']
        //     // let unLoginShowValid = ['/learn/course/micro/']
        //     let unLoginShow = false
        //     unLoginShowValid.map(el => {
        //         if (window.location.pathname.indexOf(el) != -1 || window.location.pathname == '/') {
        //             unLoginShow = true
        //         }
        //     })
        //     // if (
        //     //     !unLoginShow &&
        //     //     !window.hasLogin &&
        //     //     !exceptNoLogin.includes(window.location.pathname)
        //     // ) {
        //     //     window.location.href = this.loginHref; // 退出登录
        //     // }
        // },
        loginOut() {
            // 修改退出登录逻辑(使用重定向接口，登录页不带redicturl)
            ////用户退出登录埋码
            window.depthStatistics({
                platform: 'aplus_queue',
                params: { action: 'aplus.setMetaInfo', arguments: ["_user_id", null] }
            })
            // if (this.bannerPlateType == 15) {
            //     window.location.href = '/unifiedlogin/#/login'
            // } else {
            //     window.location.href = "/unifiedlogin/v1/loginmanage/loginout/go";
            // }
            window.location.href = "/unifiedlogin/v1/loginmanage/loginout/go";
        },
        microMajorLoginOut() {
            // 修改退出登录逻辑(使用重定向接口，登录页不带redicturl)
            ////用户退出登录埋码
            window.depthStatistics({
                platform: 'aplus_queue',
                params: { action: 'aplus.setMetaInfo', arguments: ["_user_id", null] }
            })
            window.location.href = "/unifiedlogin/v1/loginmanage/loginout/go?redirect_url=" + encodeURIComponent(location.origin + '/learn/search/microMajor')

        },
        //文件下载
        fileDownload(file) {
            if (!file) return;
            let { path, name } = file;
            var a = document.createElement("a");
            a.download = name;
            a.href = path;
            a.rel = "noopener noreferrer";
            jQuery("body").append(a); // 修复firefox中无法触发click
            a.click();
            jQuery(a).remove();
        },
        scrollNavInit() {
            // console.log('scrollNavInit')
            let that = this

            let scrollBox
            if (document.querySelector('.scroll_container')) {
                scrollBox = document.querySelector('.scroll_container')
            } else {
                scrollBox = document.documentElement
            }

            let top = scrollBox.scrollTop
            if (that.bannerPlateType == '1') {
                if (top > (that.bannerHeight - 80) && that.headActive) {
                    that.headActive = false
                    // that.$message.error(that.headActive)
                } else if (top <= (that.bannerHeight - 80) && !that.headActive) {
                    that.headActive = true
                    // that.$message.success(that.headActive)
                }
            } else if (that.bannerPlateType == '2') {
                let h = scrollBox.scrollHeight - window.innerHeight //防止收缩后页面反复抖动
                if (h <= 200) return
                // console.log(top, h)
                if (top > 100 && that.headActive) {
                    that.headActive = false
                } else if (top <= 100 && !that.headActive) {
                    that.headActive = true
                }
            } else if (that.bannerPlateType == '3' || that.bannerPlateType == '4') {
                let h = scrollBox.scrollHeight - window.innerHeight //防止收缩后页面反复抖动
                if (h <= 200) return
                // console.log(top, h)
                if (top > 126 && that.headActive) {
                    that.headActive = false
                } else if (top <= 126 && !that.headActive) {
                    that.headActive = true
                }
            } else if (that.bannerPlateType == '5') {
                if (top > (that.bannerHeight - 80) && that.headActive) {
                    that.headActive = false
                    // that.$message.error(that.headActive)
                } else if (top <= (that.bannerHeight - 80) && !that.headActive) {
                    that.headActive = true
                    // that.$message.success(that.headActive)
                }
            }
        },
        //初始化省平台职教数据-导航
        // initBannerType4() {
        //     if (this.bannerPlateType == 4) {
        //         console.log('初始化模板4')
        //
        //         API.reqCourseCategories().then(res => {
        //             // console.log(res)
        //             if (res.status == 200) {
        //                 const {classificationType = []} = res.data
        //                 let arr = classificationType.filter(el => el.isEnable == 1)
        //                 // console.log(arr)
        //                 this.navClassificationTypeList = arr
        //             }
        //         })
        //     }
        // },
        //点击事件埋码
        handleClickEventStatistics(eventCode, params) {
            window.depthStatistics({
                platform: 'aplus_queue',
                params: { action: 'aplus.record', arguments: [eventCode, 'CLK', params] }
            })
        },
        //首页轮播点击埋码
        bannerEventClick(e) {
            this.handleClickEventStatistics('picture_click', { picture_name: e.srcElement.alt })
        },
        //首页分类点击事件埋码
        categoryEventClick(params) {
            let defaultParams = {
                top_ctgy_name: '',
                top_ctgy_id: '',
                sec_ctgy_name: '',
                sec_ctgy_id: '',
                third_ctgy_name: '',
                third_ctgy_id: ''
            }
            this.handleClickEventStatistics('cate_click', { ...defaultParams, ...params })
        },
        //课程点击事件埋码
        courseEventClick(e) {
            this.handleClickEventStatistics('course_click', {
                course_name: e.currentTarget.dataset.name,
                course_id: e.currentTarget.dataset.id,
                college_name: e.currentTarget.dataset.college,
                major_name: e.currentTarget.dataset.major,
            })
            //统计课程点击量
            API.reqCourseViewCount({
                courseId: e.currentTarget.dataset.id,
                courseType: e.currentTarget.dataset.type,
            })
        },
        //课程点击加入学习按钮事件
        courseJoinEventClick(e) {
            this.handleClickEventStatistics('course_learn_button_click', {
                course_name: e.currentTarget.dataset.name,
                course_id: e.currentTarget.dataset.id,
            })
        },
        //首页导航点击事件
        navigationBarEventClick(e) {
            let category_name = e.currentTarget.innerHTML
            let category_id = e.currentTarget.dataset.id
            this.handleClickEventStatistics('category_click', { category_name, category_id })
        },
        /**
         * 获取是否是pc端页面
         */
        getIfPc() {
            const width = window.innerWidth
            if (width > 768) {
                return true
            } else {
                return false
            }
        },
        platformClick(e) {
            let platform = _third_platform.find(el => el.label == e.currentTarget.innerText.trim())
            window.open('/learn/search?platformType=' + (platform ? platform.value : '10')) //10默认本平台
        },
        arraryIncludes(arr, el) {
            let flag = false;
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] == el) flag = true
            }
            return flag
        },
        //获取搜索历史
        queryHistoryAsync(name, cb, type = 0, searchType = 0) {
            // console.log(name)
            //searchType:0-门户，1-资源库
            searchType = 0 //门户与资源库不做区分了
            if (!name) {
                //获取搜索历史
                Promise.all([API.reqSearchHistoryList({ type: searchType }), API.reqHotKeyword()]).then(arr => {
                    let data = []
                    let history = { history: (arr[0] && arr[0].status == 200 && arr[0].data.length) ? arr[0].data : [], }
                    this.searchHistoryList = history.history
                    history.history.length && data.push(history)
                    let hot = { hot: (arr[1] && arr[1].status == 200 && arr[1].data.length) ? arr[1].data : [], }
                    hot.hot.length && data.push(hot)
                    return cb(data)
                }).catch(() => {
                    return cb([])
                })
            } else {
                //获取关键词联想
                API.reqKeywordLenovoList({ name, type }).then(res => {
                    if (res.status == 200) {
                        let data = res.data.filter((_, i) => i < 10).map(name => ({ name, ifLenovo: true }))
                        if (!data.length) return cb([])
                        cb([{ lenovo: data }])
                    }
                })
            }
        },
        //删除搜索历史
        handleSearchHistoryDelete(item) {
            console.log(item)
            API.reqSearchHistoryDel([item.id]).then(res => {
                if (res.status == 200) {
                    if (this.getIfPc()) {
                        this.$refs.search_history_box.focus()
                    } else {
                        this.$refs.search_history_box_mobile.focus()
                    }
                }
            })
        },
        //清空搜索历史
        handleSearchHistoryClear() {
            if (this.searchHistoryList.length)
                API.reqSearchHistoryDel(this.searchHistoryList.map(el => el.id).filter(el => el)).then(res => {
                    if (res.status == 200) {
                        if (this.getIfPc()) {
                            this.$refs.search_history_box.focus()
                        } else {
                            this.$refs.search_history_box_mobile.focus()
                        }
                    }
                })
        },
        //点击课程直播前判断是否是直播班级课成员
        handleCourseLiveTarget(e) {
            const that = this
            let liveId = e.currentTarget.getAttribute('data-id')
            let href = e.currentTarget.getAttribute('href')
            if (href.includes('course')) {
                API.reqIfCourseLive({ liveId }).then(res => {
                    if (res.status == 200 && res.data) {
                        window.open(href)
                    } else {
                        that.$message.warning('您没有加入本门课程，暂时不能观看直播哦~')
                    }
                }).catch(err => {
                    if (err.status == 401) {
                        that.$message.info('请先登录！')
                        location.href = this.loginHref
                    } else {
                        that.$message.warning('您没有加入本门课程，暂时不能观看直播哦~')
                    }
                })
            } else {
                window.open(href)
            }
        },
        //全局封装加入课程操作,chooseRole-是否学生角色加入(0-管理员，1-学生)
        async handleGlobalJoinCourse({ courseId, semester, sectionId, pointId, chooseRole, pointNodeId, ifMicro }) {
            const that = this
            //判断课程可加入状态
            function getJoinBtnDisable(courseInfo) {
                let courseType = courseInfo.entityData.courseType
                const currentDate = (new Date()).getTime()
                let { start_time, end_time } = courseInfo.entityData
                let isEnd = end_time && (end_time <= currentDate)
                //spoc开课7天前可进入详情页
                if (courseType === 2 || courseType === 3) {
                    // return false
                    start_time = new Date(start_time).getTime() - 7 * 24 * 60 * 60 * 1000
                }
                let isStart = start_time ? ((new Date(start_time)).getTime() <= currentDate) : true
                //允许结课后加入
                let allowContinueStydy = courseInfo.entityData.course_finish_continue_learning
                // return !isStart || isEnd
                if (!isStart) {
                    if (courseType === 2 || courseType === 3) {
                        return '课程开始前7天可进入'
                    } else {
                        return '课程未开始'
                    }
                } else if (isEnd) {
                    if (allowContinueStydy) {
                        return false
                    } else {
                        return '课程已结束'
                    }
                } else {
                    return false
                }
            }
            //判断该用户进入spoc时是否需要调加入接口
            function shouldIJoin(courseInfo) {
                let teacherCodes = courseInfo.entityData.teacher
                // console.log(that.loginUserInfo)
                if (that.loginUserInfo && that.loginUserInfo.roles) {
                    const excludeRoles = ['r_sys_manager', 'r_course_manager', 'admin_S1', 'r_second_manager']
                    let state = true //true为需要调接口
                    //sys、课程管理员、admin、zhiliao不需调加入接口
                    excludeRoles.map(role => {
                        if (that.loginUserInfo.roles.includes(role)) {
                            state = false
                        }
                    })
                    // console.log(teacherInfo)
                    if (teacherCodes.includes(that.loginUserInfo.user_code)) {
                        state = false
                    }
                    return state
                } else {
                    return false
                }
            }
            //判断课程资源是否被删除
            const res = await API.reqCourseResourceExist({ courseId })
            if (res && res.status == 200 && !res.data) {
                return this.$message.info(this.$t('资源已删除！'))
            }
            // return
            //微课直接跳转
            if (ifMicro) {
                if (pointId) {
                    window.open('/learn/course/micro/' + courseId + '?point=' + pointId)
                } else {
                    window.open('/learn/course/micro/' + courseId)
                }
                return
            }
            return new Promise((resolve, reject) => {
                //获取课程信息
                API.reqCourseInfo({ courseId, courseSemester: semester }).then(res => {
                    if (res.status == 200) {
                        let courseInfo = res.data
                        let courseType = courseInfo.entityData.courseType

                        let href = ''
                        if (sectionId && pointId) {
                            href = '/learn/course/' + (courseInfo.courseType == 1 ? 'mooc/' : 'spoc/') + courseId + '/' + sectionId + '?semester=' + (semester || '') + '&pointId=' + pointId
                        } else if (pointNodeId) {
                            //跳转知识节点
                            href = '/learn/course/detail/' + (courseInfo.courseType == 1 ? 'mooc/' : 'spoc/') + 'courseMap/' + courseId + '?semester=' + (semester || '') + '&selectnodeid=' + pointNodeId
                        } else {
                            href = '/learn/course/detail/' + (courseInfo.courseType == 1 ? 'mooc/' : 'spoc/') + 'courseWare/' + courseId
                        }
                        // 未登录
                        if (!window.hasLogin) {
                            if (courseInfo.entityData.unLoginShow) {
                                //对外公开，未登录也可直接跳转
                                window.open(href)
                                return
                            } else {
                                //未对外公开且未登录，跳转登录
                                that.$message.info('请登录')
                                location.href = that.loginHref
                                return
                            }
                        }

                        //不可进入
                        let diableMsg = getJoinBtnDisable(courseInfo)
                        if (diableMsg) {
                            this.$message.info(diableMsg)
                            resolve({ code: 1 }) //不可加入状态描述
                            return
                        }

                        //结课后可学习
                        if ((courseInfo.enableJoin && chooseRole != 1) || courseInfo.isJoin || (courseInfo.entityData.course_finish_continue_learning && !courseInfo.enableJoin)) {
                            //course_finish_continue_learning 已加入且结课后可进入学习 ，直接跳转详情页
                            window.open(href)
                            return
                        }

                        //管理员选择非学生角色且未加入公开课
                        if (that.ifManager && !chooseRole && !courseInfo.isJoin && courseType == 1) {
                            resolve({ code: 2, href })
                            //通过对返回值判断分别进行逻辑处理（可用返回值的href直接跳转、亦可弹框）
                            return
                        }

                        //以下未未加入状态，进行是否调接口加入判断
                        let flag = false //false未不需要调接口
                        if (!courseInfo.isJoin) {
                            if (courseType == 1 && !courseInfo.enableJoin) {
                                // mooc enableJoin false并且未加入需调接口
                                flag = true
                            } else if ((courseType == 2 || courseType === 3) && courseInfo.enableJoin && shouldIJoin(courseInfo)) {
                                //spoc enableJoin true 并且 未加入 并且 非相应角色，enableJoin字段与mooc相反
                                flag = true
                            } else if (chooseRole) {
                                //管理员学生角色也需要调加入接口
                                flag = true
                            } else {
                                //未知状态，直接跳转preview页
                                return window.open('/learn/course/preview/' + (courseInfo.courseType == 1 ? 'mooc/' : 'spoc/') + courseId)
                            }
                        }
                        if (flag) {
                            debugger
                            // 调加入接口
                            let param = {
                                courseId,
                                courseType
                            }
                            if (chooseRole != undefined) param.chooseRole = chooseRole
                            API.reqCourseJion(param).then(res => {
                                if (res.status === 200) {
                                    this.$message.success('加入课程成功');
                                    window.open(href)
                                } else {
                                    this.$message.error(res.message || '发生了错误');
                                }
                            }).catch(err => {
                                this.$message.error('发生了错误');
                            })
                        } else {
                            window.open(href)
                        }

                    } else {
                        return Promise.reject({ statusText: 'Unauthorized' })
                    }
                }).catch(err => {
                    if (err.statusText == 'Unauthorized') {
                        this.$message.warning('请登录！')
                        location.href = that.loginHref
                    }
                })
            })
        },
        //切换语言
        handleChangeLanguage(lang) {
            this.lang = lang
            localStorage.setItem('lang', lang)
            location.reload()
        },
        dateFormate,
        handleCommand,
        handleKeyword(msg) {
            this.navSearchKeyword = msg
            if (this.bannerPlateType == '9') {
                this.handerNavSearch()
            }
        },
        handleShTechBg() {
            const contentBg = document.querySelector('#shTech_bg .content_bg')
            if (contentBg) {
                contentBg.style.height = window.innerHeight + 'px'
                contentBg.style.width = window.innerWidth + 'px'
            }
        },
        getDefaultAvatar() {
            let src = this.baseUrl + '/learn/static/imgs/default_avatar.png'
            const sex = this.loginUserInfo.extend.sex
            if (this.loginUserInfo.avatar) {
                src = this.baseUrl + this.loginUserInfo.avatar
            } else {
                if (sex == '男') {
                    src = this.baseUrl + '/learn/static/imgs/default_boy_avatar.png'
                }
                if (sex == '女') {
                    src = this.baseUrl + '/learn/static/imgs/default_girl_avatar.png'
                }
            }
            return src
        },
        getCourseTargetHref(course) {
            return '/learn/' + (course.type_ == 'biz_sobey_course' ?
                'course/micro/' :
                (course.type_ == 'biz_sobey_teaching_courses' && course.courseType == 1) ?
                    'course/preview/mooc/' :
                    (course.type_ == 'biz_sobey_teaching_courses' && course.courseType == 2) ?
                        'course/preview/spoc/' :
                        'course/preview/thirdparty/') + course.contentId_
        },
        handleLoginJump(e) {
            if (!this.hasLogin) {
                e.preventDefault()
                location.href = "/unifiedlogin/v1/loginmanage/login/direction?redirect_url=" + location.href
            }
        },
        hitsNumberFormat(num) {
            if (num > 10000) {
                return (num / 10000).toFixed(1) + 'w+'
            } else {
                return num
            }
        },
    },
});
